"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var items_sort_reserved_words_1 = __importDefault(require("../constants/items-sort-reserved-words"));

exports.GOOGLE_SIGN_IN_IOS_CLIENT_ID = '794765460933-irrlfeh5vdbilcal4bip6lb13odctg5d.apps.googleusercontent.com';
exports.FACEBOOK_APP_ID = '2099141073541011';
exports.DEFAULT_CAN_GROUP_OWNER_EDIT_CONTRIBUTION = true;
exports.MAX_ITEMS_IN_GROUP = 9999;
exports.MAX_IMGS_IN_ITEM = 32;
exports.DEFAULT_IS_GROUP_OWNER_RECEIVE_NOTIFICATION_CONTRIBUTION = true;
exports.DEFAULT_IS_AUTO_APPROVE_CONTRIBUTIONS = false;
exports.DEFAULT_GROUP_EDIT_IS_PUBLIC_DATABASE = true;
exports.GROUPS_SEARCH_MAX_LENGTH = 32;
exports.APP_SCHEME = 'codb';
exports.MAX_LABEL_LENGTH = 16;
exports.MAX_NICKNAME_LENGTH = 16;
exports.WEB_DOMAIN = 'codb.io';
exports.APP_LINK_GOOGLE_PLAY = 'https://play.google.com/store/apps/details?id=com.elfwill.codb';
exports.APP_LINK_IOS = "https://apps.apple.com/us/app/codb/id1473404972";
exports.SLACK_INVITE_LINK = "https://join.slack.com/t/codbio/shared_invite/enQtNzQ2ODIzNDkwNzA3LWQ1OTExZjhkZWVmNjNiNTMwNTM0ZWQ2NTRhZmYyYTcxYmIzNmI0NmM2YzQ2NmE3MTllMDBhZjI2MDRlNTNiZTA";
exports.DEFAULT_REVERSE_DATASET_LABELS = [items_sort_reserved_words_1.default.EDIT_AT];
exports.MAX_GROUP_DESC_LENGTH = 512;